import Vue from 'vue';
import Vuex from 'vuex';

import { fetchUser } from '@/common/api/requests';
import i18n from '@/i18n';
import sites from './modules/sites';
import researches from './modules/researches';

Vue.use(Vuex);


const store = new Vuex.Store({
  state: {
    authTokenExists: localStorage.getItem('auth-token') !== null,
    breadcrumbs: null,
    coinAccountChanged: false,
    globalError: null,
    org: null,
    scrollTop: 0,
    user: {
      isAuthenticated: false,
    },
  },
  actions: {
    async refreshUser(state) {
      const response = await fetchUser();
      if (response.status === 401) {
        state.commit('logout');
      }

      const userData = response.data;
      userData.isAuthenticated = true;
      if (userData.memberships) {
        userData.memberships.forEach((membershipObj) => {
          if (membershipObj.primary) {
            const { organisation } = membershipObj;
            organisation.isVerified = membershipObj.is_verified;
            state.commit('setOrg', organisation);
          }
        });
      }

      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      if (!['nl', 'fa', 'de'].includes(params.lang)) {
        i18n.locale = userData.config.language;
      }
      store.commit('setUser', userData);
    },
  },
  getters: {
    authTokenExists(state) {
      return state.authTokenExists;
    },
    breadcrumbs(state) {
      return state.breadcrumbs;
    },
    coinAccountChanged(state) {
      return state.coinAccountChanged;
    },
    globalError(state) {
      return state.globalError;
    },
    org(state) {
      return state.org;
    },
    scrollTop(state) {
      return state.scrollTop;
    },
    user(state) {
      return state.user;
    },
  },
  mutations: {
    login(state, payload) {
      localStorage.setItem('auth-token', payload.token);
      state.authTokenExists = true;
    },
    logout(state) {
      localStorage.removeItem('auth-token');
      localStorage.removeItem('su');
      state.authTokenExists = false;
      this.commit('setUser', { isAuthenticated: false });
      this.commit('setOrg', null);
    },
    setBreadcrumbs(state, payload) {
      state.breadcrumbs = payload;
    },
    setCoinAccountChanged(state, changed) {
      state.coinAccountChanged = changed;
    },
    setGlobalError(state, payload) {
      state.globalError = payload;
    },
    setOrg(state, payload) {
      state.org = payload;
    },
    setProfilePicture(state, payload) {
      state.user.profile.picture = payload.picture;
    },
    setScrollTop(state, payload) {
      state.scrollTop = payload;
    },
    setUser(state, payload) {
      state.user = payload;
      if (state.user.su) {
        localStorage.setItem('su', '1');
      }
    },
    updateOrg(state, payload) {
      state.org = Object.assign(state.org, payload);
    },
  },
  modules: {
    sites,
    researches,
  },
});

export default store;
